module.exports = __webpack_public_path__ + "media/images/webpage/hotels/2669/meal-4719e5c0db4637e29cb81958fac7747f.webp";